import { render, staticRenderFns } from "./Job.vue?vue&type=template&id=6a2699cc&scoped=true&"
import script from "./Job.vue?vue&type=script&lang=js&"
export * from "./Job.vue?vue&type=script&lang=js&"
import style0 from "./Job.vue?vue&type=style&index=0&id=6a2699cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2699cc",
  null
  
)

export default component.exports